import { createSlice } from "@reduxjs/toolkit";

export const bulkTransactionsSlice = createSlice({
    name: 'bulkTransactions',
    initialState: {
        mode: 'deposit',
        amount: '',
        active: false
    },
    reducers: {
        changeTransactionMode: (state, action) => {
            return {
                ...state,
                mode: action.payload
            }
        },
        changeBulkTransactionAmount: (state, action) => {
            return {
                ...state,
                amount: action.payload
            }
        },
        changeFormActive: (state, action) => {
            return {
                ...state,
                active: action.payload
            }
        },
        clearBulkTransactionForm: (state) => {
            return {
                ...state,
                amount: ''
            }
        }
    }
})

export const selectBulkTransactionMode = (state) => state.bulkTransactions.mode;
export const selectBulkTransactionAmount = (state) => state.bulkTransactions.amount;
export const selectBulkTransactionFormActive = (state) => state.bulkTransactions.active;

export const {
    changeTransactionMode,
    changeBulkTransactionAmount,
    changeFormActive
} = bulkTransactionsSlice.actions;

export default bulkTransactionsSlice.reducer;
